import { z } from 'zod';

/** String field that transforms empty strings to null. For optional fields sent to the API. */
export const optionalString = () =>
  z.string().transform(v => v === '' ? null : v).nullable().optional();

/** Required non-empty string. */
export const requiredString = () =>
  z.string().min(1);

/** Coerce a form input to number. Handles empty string → undefined (will fail required check). */
export const coerceNumber = () =>
  z.preprocess(
    (val) => {
      if (val === '' || val === null || val === undefined) return undefined;
      const n = Number(val);
      return isNaN(n) ? val : n;
    },
    z.number()
  );

/** Optional coerced number — empty string becomes null. */
export const optionalNumber = () =>
  z.preprocess(
    (val) => {
      if (val === '' || val === null || val === undefined) return null;
      const n = Number(val);
      return isNaN(n) ? val : n;
    },
    z.number().nullable().optional()
  );

/** Optional date string — empty string becomes null. */
export const optionalDate = () =>
  z.string().transform(v => v === '' ? null : v).nullable().optional();

/** Required date string — must not be empty. */
export const requiredDate = () =>
  z.string().min(1);
